import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadPersonnelTrainingById: IPersonnelTrainingLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_PERSONNELTRAINING_LOAD_BY_ID,
            id
        }
    },
    LoadPersonnelTrainingByPersonnelId: IPersonnelTrainingLoadByPersonnelIdActionCreator = (personnelId) => {
        return {
            type: ACTION_PERSONNELTRAINING_LOAD_BY_PERSONNELID,
            personnelId
        }
    },
    LoadSuccess: IPersonnelTrainingLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_PERSONNELTRAINING_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IPersonnelTrainingLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNELTRAINING_LOAD_FAILURE,
            responseStatus
        }
    },

    CreatePersonnelTraining: IPersonnelTrainingCreateActionCreator = (personnelId) => {

        return {
            type: ACTION_PERSONNELTRAINING_CREATE,
            personnelId,
        }
    },
    CreateSuccess: IPersonnelTrainingCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_PERSONNELTRAINING_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IPersonnelTrainingCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNELTRAINING_CREATE_FAILURE,
            responseStatus
        }
    },

    SavePersonnelTraining: IPersonnelTrainingSaveActionCreator = (formData) => {
        return {
            type: ACTION_PERSONNELTRAINING_SAVE,
            formData
        }
    },
    SaveSuccess: IPersonnelTrainingSaveSuccessActionCreator = (formData, formState, lookups, responseStatus) => {
        return {
            type: ACTION_PERSONNELTRAINING_SAVE_SUCCESS,
            formData,
            formState,
            lookups,
            responseStatus
        }
    },
    SaveFailure: IPersonnelTrainingSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNELTRAINING_SAVE_FAILURE,
            responseStatus
        }
    },
    
    ValidatePersonnelTraining: IPersonnelTrainingValidateActionCreator = (formData) => {
        return {
            type: ACTION_PERSONNELTRAINING_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IPersonnelTrainingValidateSuccessActionCreator = (formData, formState, lookups, responseStatus) => {
        return {
            type: ACTION_PERSONNELTRAINING_VALIDATE_SUCCESS,
            formData,
            formState,
            lookups,
            responseStatus
        }
    },
    ValidateFailure: IPersonnelTrainingValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNELTRAINING_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IPersonnelTrainingClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PERSONNELTRAINING_CLEAR,
            propertiesToClear
        }
    };



export const
    ACTION_PERSONNELTRAINING_LOAD_BY_ID = "ACTION_PERSONNELTRAINING_LOAD_BY_ID",
    ACTION_PERSONNELTRAINING_LOAD_BY_PERSONNELID = "ACTION_PERSONNELTRAINING_LOAD_BY_PERSONNELID",
    ACTION_PERSONNELTRAINING_LOAD_SUCCESS = "ACTION_PERSONNELTRAINING_LOAD_SUCCESS",
    ACTION_PERSONNELTRAINING_LOAD_FAILURE = "ACTION_PERSONNELTRAINING_LOAD_FAILURE",
    
    ACTION_PERSONNELTRAINING_CREATE = "ACTION_PERSONNELTRAINING_CREATE",
    ACTION_PERSONNELTRAINING_CREATE_SUCCESS = "ACTION_PERSONNELTRAINING_CREATE_SUCCESS",
    ACTION_PERSONNELTRAINING_CREATE_FAILURE = "ACTION_PERSONNELTRAINING_CREATE_FAILURE",

    ACTION_PERSONNELTRAINING_SAVE = "ACTION_PERSONNELTRAINING_SAVE",
    ACTION_PERSONNELTRAINING_SAVE_SUCCESS = "ACTION_PERSONNELTRAINING_SAVE_SUCCESS",
    ACTION_PERSONNELTRAINING_SAVE_FAILURE = "ACTION_PERSONNELTRAINING_SAVE_FAILURE",

    ACTION_PERSONNELTRAINING_VALIDATE = "ACTION_PERSONNELTRAINING_VALIDATE",
    ACTION_PERSONNELTRAINING_VALIDATE_SUCCESS = "ACTION_PERSONNELTRAINING_VALIDATE_SUCCESS",
    ACTION_PERSONNELTRAINING_VALIDATE_FAILURE = "ACTION_PERSONNELTRAINING_VALIDATE_FAILURE",

    ACTION_PERSONNELTRAINING_CLEAR = "ACTION_PERSONNELTRAINING_CLEAR";


export interface IPersonnelTrainingLoadSuccessAction {
    type: "ACTION_PERSONNELTRAINING_LOAD_SUCCESS";
    formData: Dtos.PersonnelTraining | Dtos.PersonnelTraining[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelTrainingLoadSuccessActionCreator {
    (
        formData: Dtos.PersonnelTraining | Dtos.PersonnelTraining[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelTrainingLoadSuccessAction;
}

export interface IPersonnelTrainingLoadFailureAction {
    type: "ACTION_PERSONNELTRAINING_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelTrainingLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelTrainingLoadFailureAction;
}

export interface IPersonnelTrainingLoadByIdAction {
    type: "ACTION_PERSONNELTRAINING_LOAD_BY_ID";
    id: number;
}

export interface IPersonnelTrainingLoadByIdActionCreator {
    (id: number): IPersonnelTrainingLoadByIdAction;
}

export interface IPersonnelTrainingLoadByPersonnelIdAction {
    type: "ACTION_PERSONNELTRAINING_LOAD_BY_PERSONNELID";
    personnelId: number;
}

export interface IPersonnelTrainingLoadByPersonnelIdActionCreator {
    (personnelId: number): IPersonnelTrainingLoadByPersonnelIdAction;
}

export interface IPersonnelTrainingCreateAction {
    type: "ACTION_PERSONNELTRAINING_CREATE";
    personnelId: number;
}

export interface IPersonnelTrainingCreateActionCreator {
    (
        personnelId: number
    ): IPersonnelTrainingCreateAction
}

export interface IPersonnelTrainingCreateSuccessAction {
    type: "ACTION_PERSONNELTRAINING_CREATE_SUCCESS";
    formData: Dtos.PersonnelTraining;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IPersonnelTrainingCreateSuccessActionCreator {
    (
        formData: Dtos.PersonnelTraining,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IPersonnelTrainingCreateSuccessAction;
}

export interface IPersonnelTrainingCreateFailureAction {
    type: "ACTION_PERSONNELTRAINING_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IPersonnelTrainingCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelTrainingCreateFailureAction;
}


export interface IPersonnelTrainingSaveAction {
    type: "ACTION_PERSONNELTRAINING_SAVE";
    formData: Dtos.PersonnelTraining;

}

export interface IPersonnelTrainingSaveActionCreator {
    (
        formData: Dtos.PersonnelTraining,
    ): IPersonnelTrainingSaveAction;
}

export interface IPersonnelTrainingSaveSuccessAction {
    type: "ACTION_PERSONNELTRAINING_SAVE_SUCCESS";
    formData: Dtos.PersonnelTraining;
    formState: Dtos.FormState,
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelTrainingSaveSuccessActionCreator {
    (
        formData: Dtos.PersonnelTraining,
        formState: Dtos.FormState,
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelTrainingSaveSuccessAction;
}

export interface IPersonnelTrainingSaveFailureAction {
    type: "ACTION_PERSONNELTRAINING_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IPersonnelTrainingSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelTrainingSaveFailureAction;
}

export interface IPersonnelTrainingValidateAction {
    type: "ACTION_PERSONNELTRAINING_VALIDATE";
    formData: Dtos.PersonnelTraining;

}

export interface IPersonnelTrainingValidateActionCreator {
    (
        formData: Dtos.PersonnelTraining,
    ): IPersonnelTrainingValidateAction;
}

export interface IPersonnelTrainingValidateSuccessAction {
    type: "ACTION_PERSONNELTRAINING_VALIDATE_SUCCESS";
    formData: Dtos.PersonnelTraining;
    formState: Dtos.FormState,
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelTrainingValidateSuccessActionCreator {
    (
        formData: Dtos.PersonnelTraining,
        formState: Dtos.FormState,
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelTrainingValidateSuccessAction;
}

export interface IPersonnelTrainingValidateFailureAction {
    type: "ACTION_PERSONNELTRAINING_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IPersonnelTrainingValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelTrainingValidateFailureAction;
}

export interface IPersonnelTrainingClearAction {
    type: "ACTION_PERSONNELTRAINING_CLEAR";
    propertiesToClear?: string[];
}

export interface IPersonnelTrainingClearActionCreator {
    (propertiesToClear?: string[]): IPersonnelTrainingClearAction;
}

export type PersonnelTrainingAction =
    IPersonnelTrainingLoadByIdAction |
    IPersonnelTrainingLoadByPersonnelIdAction |
    IPersonnelTrainingLoadFailureAction |
    IPersonnelTrainingLoadSuccessAction |
    IPersonnelTrainingCreateAction |
    IPersonnelTrainingCreateSuccessAction |
    IPersonnelTrainingCreateFailureAction |
    IPersonnelTrainingClearAction |
    IPersonnelTrainingSaveAction |
    IPersonnelTrainingSaveSuccessAction |
    IPersonnelTrainingSaveFailureAction |
    IPersonnelTrainingValidateAction |
    IPersonnelTrainingValidateSuccessAction |
    IPersonnelTrainingValidateFailureAction;
